import { createSelector } from '@reduxjs/toolkit';
import modalsSelector from './modals';

const deletePixelConfModalSelector = createSelector(modalsSelector, (modals) => modals.deletePixelConf);

export default deletePixelConfModalSelector;
